<template>
  <div>
    <x-org-heading heading="Monitoring"></x-org-heading>
    <v-row no-gutters>
      <!-- Keeping this commented code | Create Widget can be a part of future scope -->
      <!-- <v-col md="6" sm="12" class="text-end">
        <v-btn
          :disabled="disableAddRowBtn"
          text
          :ripple="false"
          color="#58e2c2"
          large
          class="addWidget pa-0 ma-0"
          @click.stop="openAddEditWidgetDialog"
        >
          <v-icon class="mr-2" size="25">add_circle</v-icon>Add widget
        </v-btn>
      </v-col> -->
    </v-row>
    <v-row class="chartWidgets mx-0 mt-1" v-if="!hasError">
      <v-col sm="12" v-if="filteredWidgetList">
        <v-row wrap>
          <template v-for="(widget, index) in filteredWidgetList">
            <FixedSizeSmallWidgets
              v-if="widget.row === 1 || widget.row === 2 || widget.row === 3"
              :index="index"
              :widgetInfo="widget"
              :key="widget.id"
              :selectedDate="selectedDate"
              :kpiDetails="kpiDetails"
              :threeColWidgetData="widgetDataForSingleStat"
              :isLeftDrawerPanOpen="isLeftDrawerPanOpen"
            ></FixedSizeSmallWidgets>
          </template>
        </v-row>

        <v-row>
          <template v-for="widget in filteredWidgetList">
            <DynamicSizeWidgets
              v-if="widget.row !== 1 && widget.row !== 2 && widget.row !== 3"
              :widgetInfo="widget"
              :key="widget.id"
              :selectedDate="selectedDate"
              :kpiDetails="kpiDetails"
              :widgetId="widget.id"
            ></DynamicSizeWidgets>
          </template>
        </v-row>
      </v-col>
      <v-col sm="12" md="12" v-else>
        <v-row>
          <v-col
            v-for="number in 5"
            :key="number"
            :md="!isLeftDrawerPanOpen ? 3 : 3"
            :sm="!isLeftDrawerPanOpen ? 12 : ''"
            :class="{ 'fixed-widget-card': isLeftDrawerPanOpen }"
          >
            <v-skeleton-loader
              type="list-item-avatar, image"
              :elevation="4"
              :loading="true"
            ></v-skeleton-loader>
          </v-col>
          <v-col sm="6" md="6" v-for="number in 4" :key="number * 10">
            <v-skeleton-loader
              type="list-item-avatar, image"
              :elevation="4"
              :loading="true"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <AddEditWidgetDialog
      v-if="filteredWidgetList && filteredWidgetList.length"
    ></AddEditWidgetDialog>
  </div>
</template>

<script>
import AddEditWidgetDialog from '@/components/Organisations/dialogues/AddEditWidgetDialog';
import FixedSizeSmallWidgets from '@/components/Organisations/Widgets/FixedSizeSmallWidgets';
import DynamicSizeWidgets from '@/components/Organisations/Widgets/DynamicSizeWidgets';
import { mapGetters, mapMutations, mapState } from 'vuex';
import EventBus from '@/EventBus';

export default {
  props: ['isLeftDrawerPanOpen', 'title'],
  components: {
    AddEditWidgetDialog,
    FixedSizeSmallWidgets,
    DynamicSizeWidgets
  },
  data() {
    return {
      hasError: false,
      errorMsg: '',
      maxRowAllowed: 9,
      disableAddRowBtn: false,
      userData: null,
      selectedDate: '',
      widgetList: null,
      errors: [],
      widgetDataForSingleStat: [],
      sizeClass: {
        SMALL: ' md4',
        MEDIUM: ' md6',
        LARGE: ' md8'
      },
      kpiDetails: null
    };
  },
  computed: {
    ...mapState({
      addEditDialogState: state => state.dashboard.isAddEditWidgetDialogOpen,
      currentSubscription: state => state.currentSubscription
    }),
    isAddEditWidgetDialogOpen: {
      get() {
        return this.addEditDialogState;
      },
      set(value) {
        this.toggleAddEditModal(value);
      }
    },
    filteredWidgetList() {
      return !this.$can('view', 'dropbox') ||
        (this.currentSubscription?.product?.handle === 'trial' &&
          !this.isCurrentOrgLegacy)
        ? this.widgetList?.filter(
            widgetInfo =>
              widgetInfo.kpiSlug !== 'dropbox_indexed' &&
              widgetInfo.kpiSlug !== 'dropbox_indexed_size'
          )
        : this.widgetList;
    }
  },
  watch: {
    // eslint-disable-next-line
    currentlySelectedOrgId(newValue, oldValue) {
      // reset to avoid data inconsistency in case of page refresh
      this.resetBaseValues();
      // hit endpoints to get kpi list and widget conf
      this.getBaseData();
    },
    // eslint-disable-next-line
    isAddEditWidgetDialogOpen(newValue, oldValue) {
      if (!newValue) {
        // means dialog closed
        this.toggleAddRowBtn();
      }
    }
  },
  methods: {
    ...mapGetters('dashboard', [
      'getWidgetList',
      'getSelectedDashboardDate',
      'getCurrentOrgFetchedData'
    ]),
    ...mapMutations('dashboard', [
      'setKpiDetails',
      'setKpiConfig',
      'setWidgetList',
      'setSample',
      'toggleAddEditModal',
      'setSelectedForEdit',
      'setSelectedDashboardDate',
      'addNewFetchedOrg',
      'updateFetchedOrgDate'
    ]),
    ...mapMutations(['loading']),
    switchTheme() {
      document.getElementById('themeDark').setAttribute('disabled', false);
      document.getElementById('themeLight').removeAttribute('disabled');
    },
    toggleAddRowBtn() {
      const count = this.getRowCount();
      if (count >= this.maxRowAllowed) {
        this.disableAddRowBtn = true;
        return;
      }
      this.disableAddRowBtn = false;
    },
    getRowCount() {
      let list = this.widgetList;
      let rowArr = [];
      list.forEach(item => {
        if (rowArr.indexOf(item.row) === -1) {
          rowArr.push(item.row);
        }
      });
      return rowArr.length;
    },
    resetBaseValues() {
      this.toggleAddEditModal(false);
      this.setKpiDetails([]);
      this.setKpiConfig([]);
      this.setWidgetList([]);
    },
    async getBaseData() {
      this.selectedDate =
        this.getSelectedDashboardDate() || new Date().toISOString();
      try {
        this.hasError = false;
        // kpi info
        let kpiList = await this.axios.get(
          this.getServiceURL('baseUrlForAnalyticsService') + '/kpi'
        );
        this.processKPIList(kpiList);

        // dashboard conf for current user: rows and widgets per row etc
        let widgetConfig = await this.axios.get(
          this.getServiceURL('baseUrlForConfig') +
            '/config/' +
            this.userData.preferred_username +
            '/' +
            this.currentlySelectedOrgId
        );
        this.processWidgetConfig(widgetConfig);

        // info about different widget types available in system
        let widgetTypeList = await this.axios.get(
          this.getServiceURL('baseUrlForConfig') +
            '/dashboard/widget/types/list'
        );

        this.processWidgetTypeList(widgetTypeList);
        if (!this.getCurrentOrgFetchedData()) {
          this.addNewFetchedOrg({
            [this.currentlySelectedOrgId]: {
              completed: true,
              date: this.selectedDate
            }
          });
        } else {
          // Can't find an appropriate solution right now.
          // Moving with this solution for now.
          // For Refactor reference - https://seedcloud.atlassian.net/browse/MAIL-3270
          setTimeout(() => {
            if (this.getCurrentOrgFetchedData().date !== this.selectedDate) {
              this.updateFetchedOrgDate({
                currentOrg: this.currentlySelectedOrgId,
                selectedDate: this.selectedDate
              });
            }

            // Will solve this as part of above ticket
            // eslint-disable-next-line
          }, 3000);
        }
        this.toggleAddRowBtn();
        this.loading(false);
      } catch (e) {
        this.hasError = true;
        if (e.response && e.response.data) {
          if (e.response.data.errors.length) {
            this.snackbar('error', e.response.data.errors[0].message);
          } else {
            this.snackbar('error', this.$message.ERROR_LOADING_DATA);
          }
        } else {
          this.snackbar('error', this.$message.ERROR_LOADING_DATA);
        }
      }
    },
    processKPIList(response) {
      let data = response.data.body;

      // mutation
      this.setKpiDetails(data);
      localStorage.setItem('kpis', JSON.stringify(data));
      this.kpiDetails = data;
    },
    processWidgetConfig(response) {
      this.widgetDataForSingleStat = [];
      let widgetData = response.data.body.widgets;
      // mutation
      this.setKpiConfig(widgetData);
      localStorage.setItem('widgetData', JSON.stringify(widgetData));
      localStorage.setItem('graphApiData', JSON.stringify(widgetData));
    },
    processWidgetTypeList(response) {
      localStorage.setItem('widgetList', JSON.stringify(response.data.body));

      let widgetList = JSON.parse(localStorage.getItem('widgetList'));
      let kpiData = JSON.parse(localStorage.getItem('kpis'));
      let wd = JSON.parse(localStorage.getItem('widgetData'));

      widgetList.forEach(element => {
        for (let i = 0; i < wd.length; i++) {
          if (element.id === wd[i].widgetTypeId) {
            wd[i].widgetGraphName = element.name;
          }
        }
      });
      kpiData.forEach(element => {
        for (let i = 0; i < wd.length; i++) {
          if (element.slug === wd[i].kpiSlug) {
            wd[i].kpiIdName = element.label;
            wd[i].isStorageTypeData = element.dataKPI;
          }
        }
      });

      // mutation
      this.setWidgetList(wd);
      this.widgetList = this.getWidgetList();
    },
    calculateColWidth(isLeftDrawerPanOpen) {
      if (isLeftDrawerPanOpen) {
        this.sizeClass = {
          SMALL: ' md6',
          MEDIUM: ' md12',
          LARGE: ' md12'
        };
      } else {
        this.sizeClass = {
          SMALL: ' md4',
          MEDIUM: ' md6',
          LARGE: ' md8'
        };
      }
    },
    getCurrentUniqueRowCount() {
      let objMap = {};
      const widgetList = this.getWidgetList();
      widgetList.forEach(item => {
        if (objMap[item.row] !== undefined) {
          objMap[item.row] += 1;
        } else {
          objMap[item.row] = 0;
        }
      });
      return !Object.keys(objMap).length >= this.maxRowAllowed;
    },
    openAddEditWidgetDialog() {
      // stop in case of >8 rows
      if (!this.getCurrentUniqueRowCount()) {
        // alert('rows cant be greater than 8');
        // return false;
      }

      let objNewWidget = {
        id: null,
        kpiId: 0,
        kpiSlug: 'empty_slug',
        position: null,
        row: null,
        size: 0,
        timeUnit: 0,
        widgetTypeId: null,
        widgetGraphName: null,
        kpiIdName: null
      };
      this.setSelectedForEdit(objNewWidget);
      this.toggleAddEditModal(true);
    }
  },
  mounted() {
    EventBus.$on('getUpdatedDataOnDateChange', value => {
      this.setSelectedDashboardDate({
        selectedDate: value
      });
      this.selectedDate = value;
    });

    this.userData = JSON.parse(localStorage.getItem('userData'));

    if (localStorage.getItem('leftDrawerOpen') !== null) {
      let drawerPanOpen = JSON.parse(localStorage.getItem('leftDrawerOpen'));
      if (!drawerPanOpen) {
        this.calculateColWidth(true);
      }
    } else {
      this.calculateColWidth();
    }
    // reset to avoid data inconsistency in case of page refresh
    this.resetBaseValues();
    // hit endpoints to get kpi list and widget conf
    this.getBaseData();
  },
  beforeDestroy() {
    EventBus.$off('getUpdatedDataOnDateChange');
  }
};
</script>
<style scoped>
.fixed-widget-card {
  flex: 0 0 25%;
  max-width: 25%;
}

@media (max-width: 1264px) {
  .fixed-widget-card {
    flex: 0 0 25%;
    max-width: 25%;
  }
}

@media (max-width: 960px) {
  .fixed-widget-card {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

@media (max-width: 600px) {
  .fixed-widget-card {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>
